import { render, staticRenderFns } from "./RadiationTherapy.vue?vue&type=template&id=196a0936&"
import script from "./RadiationTherapy.vue?vue&type=script&lang=js&"
export * from "./RadiationTherapy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports